<div class="ostso-dialog">
  <div class="header">
    <h1>{{ isNew ? "Создание критерия" : "Редактирование критерия" }}</h1>
    <button mat-icon-button class="close-button" (click)="onNoClick()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div mat-dialog-content>
    <form [formGroup]="form" class="form">
      <input class="remarktype-textarea" matInput [formControlName]="'name'" placeholder="Критерий"/>
      <input class="remarktype-textarea" matInput [formControlName]="'shortName'" placeholder="Условное обозначение"/>
      <mat-expansion-panel [expanded]="true" [style]="{'background-color': '#F3F4F6' }">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Тип оценки
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="controls">
            @for (period of periods; track period.id; let index = $index) {
              <button
                class="control"
                [class.active]="form.get('period')?.value?.name===periods[index].name"
                mat-button
                (click)="changePeriod(periods[index])">{{ periods[index].name }}
              </button>
            }

          </div>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="true" [style]="{'background-color': '#F3F4F6' }">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Вес критерия
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-form-field>
          <input matInput formControlName="weight" type="number" step="0.01"/>
        </mat-form-field>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="true" [style]="{'background-color': '#F3F4F6' }">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Порядок
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-form-field>
          <input matInput formControlName="reportOrder" type="number" step="1" min="0"/>
        </mat-form-field>
      </mat-expansion-panel>

    </form>
  </div>
  <div mat-dialog-actions>
    <button class="btn btn-blue" mat-button cdkFocusInitial (click)="onApply()" [disabled]="!form.valid">Применить</button>
    <button class="btn btn-secondary" mat-button (click)="onNoClick()">Сбросить</button>
  </div>
</div>

